import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "home-search" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = {
    key: 0,
    class: "home-search__suggestions"
};
const _hoisted_5 = { class: "row" };
const _hoisted_6 = {
    key: 0,
    class: "col-xs-12 col-sm-6"
};
const _hoisted_7 = { class: "home-search__suggestions-title" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 1,
    class: "col-xs-12 col-sm-6"
};
const _hoisted_10 = { class: "home-search__suggestions-title" };
const _hoisted_11 = ["onClick"];
import { ref, watch } from 'vue';
import products from '@astina/paloma-shop-common-ui/src/services/ProductRepository';
import _debounce from 'lodash/debounce';
import { useRouter } from "vue-router";
import events from '@astina/paloma-common-ui/src/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeSearch',
    setup(__props) {
        const router = useRouter();
        const searchQuery = ref('');
        const suggestions = ref({ products: [], categories: [] });
        const listSuggestions = _debounce(listSuggestionsUndebounced, 200);
        watch(() => searchQuery.value, listSuggestions);
        async function search(type) {
            const query = searchQuery.value.trim();
            if (!query)
                return;
            events.$emit('track.home_search', { query, type });
            router.push({ name: 'catalog_category', query: { search: query } });
        }
        async function clickSuggestion(type, name, route) {
            const query = searchQuery.value.trim();
            events.$emit('track.home_suggestion', { query, type, name, route });
            router.push(route);
        }
        function listSuggestionsUndebounced() {
            const query = searchQuery.value.trim();
            if (!query) {
                suggestions.value = { products: [], categories: [] };
                return;
            }
            products.listSuggestions(query).then(s => { suggestions.value = s; });
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("form", {
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                        class: "home-search__input"
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            type: "search",
                            placeholder: _ctx.$t('search.placeholder_detailed'),
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event) => (search('enter')), ["prevent"]), ["enter"]))
                        }, null, 40, _hoisted_3), [
                            [_vModelText, searchQuery.value]
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (search('button')), ["prevent"]))
                        }, [
                            _createVNode(_component_icon, { name: "search" })
                        ]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        (suggestions.value.products.length > 0 || suggestions.value.categories.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (suggestions.value.products.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('search.suggested_products')), 1),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value.products, (product, index) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: index,
                                                        class: "home-search__suggestions-item"
                                                    }, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (clickSuggestion('suggest-product', product.name, { name: 'catalog_product', params: { id: product.itemNumber } })), ["prevent"])
                                                        }, _toDisplayString(product.name), 9, _hoisted_8)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (suggestions.value.categories.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t('search.suggested_categories')), 1),
                                            _cache[5] || (_cache[5] = _createTextVNode()),
                                            _createElementVNode("ul", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value.categories, (category, index) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: index,
                                                        class: "home-search__suggestions-item"
                                                    }, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (clickSuggestion('suggest-category', category.name, { name: 'catalog_category', params: { category: category.code } })), ["prevent"])
                                                        }, _toDisplayString(category.name), 9, _hoisted_11)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ], 32)
                ])
            ]));
        };
    }
});
